// extracted by mini-css-extract-plugin
module.exports = {"main":"screen_main__1p0W2"};